import { useContext, useState } from 'react'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useRestApi } from '../../../lib/RestApi/useRestApi'
import { API_URL } from '../../../shared/actions'

export const useAuditQuestions = () => {
  const [auditQuestion, setAuditQuestion] = useState(false)
  const { deleteNewAuditQuestion, getNewAuditQuestion } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Training Category', 'ALL_AUDITQUESTION', 'GET_ALL_AUDITQUESTION')
  const {
    AUDITQUESTION: { GET_ALL_AUDITQUESTION, ADD_AUDITQUESTION, EDIT_AUDITQUESTION, DELETE_MANY_AUDITQUESTION },
  } = API_URL

  const getAllAuditQuestion = async (dto = {}) => {
    GET_ALL(GET_ALL_AUDITQUESTION, setPaginate, getNewAuditQuestion, dto)
  }

  const addAuditQuestion = (dto) => {
    ADD(ADD_AUDITQUESTION, dto)
  }

  const updateAuditQuestion = (dto) => {
    UPDATE(EDIT_AUDITQUESTION, dto)
  }

  const getAuditQuestion = (dto) => {
    GET_SINGLE_DATA(GET_ALL_AUDITQUESTION, setAuditQuestion, dto)
  }

  const deleteManyAuditQuestion = (dto, setSelected = () => {}) => {
    console.log({ dto })
    DELETE(DELETE_MANY_AUDITQUESTION, dto, 'auditQuestionId', setSelected, deleteNewAuditQuestion, 'GET_ALL_AUDITQUESTION')
  }

  return {
    addAuditQuestion,
    getAllAuditQuestion,
    getAuditQuestion,
    auditQuestion,
    updateAuditQuestion,
    deleteManyAuditQuestion,
    loading,
    paginate,
  }
}
